import {PluginDocumentSettingPanel} from '@wordpress/edit-post';
import MetaBox from './MetaBox';
import type {PluginSettings} from '@wordpress/plugins';
import {__} from '@wordpress/i18n';
import type {PluginModule} from '@lipemat/js-boilerplate-gutenberg';
import Allowed from './Allowed';

type Module = PluginModule<PluginSettings>;

export const name: Module['name'] = 'advanced-sidebar-menu-pro-title-meta-box';

export const settings: Module['settings'] = {
	icon: 'welcome-widgets-menus',
	render: () => {
		return (
			<Allowed>
				{() => (
					<PluginDocumentSettingPanel
						name={name}
						title={__( 'Advanced Sidebar', 'advanced-sidebar-menu' )}
						icon={'welcome-widgets-menus'}
					>
						<MetaBox />
					</PluginDocumentSettingPanel>
				)}
			</Allowed>
		);
	},
};
